
import {  Card, Col, message, Radio, Row, Select, Slider, Space, Statistic, Table, TablePaginationConfig, Tag } from 'antd'
import React, { useEffect, useState } from 'react'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import DragTableRow from 'src/components/DragTableRow'
import usePage from 'src/hooks/usePage'
import {
  getGameUsageChart,
  getGameUsageReportMetrics,
  removeEmptyAttributes,
  searchGameReport,
} from 'src/api/reports'
import GameUsageReportSearch from './gameUsageReportSearch'

import { useCategoryMap } from 'src/hooks/GamesCategoryContext'
import AreaChart from 'src/components/Charts/AreaChart'
import { chartDateType, deviceMarks, deviceMarksAndroid, mncmccOptions, userType } from 'src/constants'
import { formatTimeWithSuffix } from 'src/utils/numberUtils'
import moment from 'moment'
import HourlyAppUsageChart from 'src/components/Charts/HourlyAppUsageChart'
import { EyeOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { SorterResult, TableCurrentDataSource } from 'antd/lib/table/interface'

const { Column } = Table

const GameUsageReportPage: React.FC = () => {
  const {
    pageData,
    onQuery,
    appendSearchForm,
    appendSearchFormMap,
    submitSearchForm,
    fetchList,
    queryObj,
    searchForm,
  } = usePage({
    getData: searchGameReport,
    searchData: searchGameReport,
    searchType: 'POST',
  })
  const { categoryMap, filterGamesByType, findCategoriesForGame } =
    useCategoryMap()
  const [chartData, setChartData] = useState([])
  const [metricsData, setMetricsData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [groupByForGame, setGroupByForGame] = useState(chartDateType[0]?.value)
  const initialEndDate = moment().endOf('day').format('YYYY-MM-DD')
  const initialStartDate = moment().startOf('day').format('YYYY-MM-DD')
  const [startDate, setStartDate] = useState(initialStartDate)
  const [endDate, setEndDate] = useState(initialEndDate)
  pageData.data.forEach((gameData) => {
    const categories = findCategoriesForGame(gameData.gameId)
    gameData.categories = categories
  })
  const appUsageChartColor = ['#181c84', '#000000', '#5BB2FF']
  type SortItem = { field: string; order: 'asc' | 'desc' };

const handleTableChange = (
  pagination: TablePaginationConfig,
  _filters: Record<string, (string | number | boolean)[] | null>,
  sorter: SorterResult<any> | SorterResult<any>[],
  extra: TableCurrentDataSource<any>
) => {
  const current = pagination.current ?? 1;
  const pageSize = pagination.pageSize ?? (parseInt(pageData.query.pageSize) || 10);


  const sorterArr = Array.isArray(sorter) ? sorter : [sorter];
  const sorts: SortItem[] = sorterArr
    .filter((s) => s && s.field && s.order)
    .map((s) => ({
      field: String(s.field),
      order: s.order === 'ascend' ? 'asc' : 'desc',
    }));


  if (extra.action === 'paginate') {
    appendSearchForm({ buttonAction: '' });
    onQuery({
      page: String(current - 1),
      pageSize: String(pageSize),
    });
    return;
  }

  
  if (extra.action === 'sort') {
    onQuery({
      page: String(current - 1),
      pageSize: String(pageSize),
      sorts: JSON.stringify(sorts),
    });
    return;
  }

  
  if (extra.action === 'filter') {
    onQuery({
      page: String(current - 1),
      pageSize: String(pageSize),
      sorts: JSON.stringify(sorts),
    });
  }
};
const selectedAccessLevels = userType?.map(item => item.value) ?? [];
   
    const chartPayload = {
      ...searchForm.current,
      aggregateBy: groupByForGame, 
      userAccessType: selectedAccessLevels
    };
    const metricsPayload = {
      ...searchForm.current,
      aggregateBy: chartDateType[0]?.value, 
      userAccessType: selectedAccessLevels
    };
  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const [chartData, metrics] = await Promise.all([
          getGameUsageChart(removeEmptyAttributes(chartPayload)),
          getGameUsageReportMetrics(removeEmptyAttributes(metricsPayload)),
        ])

        setChartData(chartData)
        setMetricsData(metrics)
      } catch (error) {
        message.error('Failed to load chart data.')
      } finally {
        setLoading(false)
      }
    }

    fetchChartData()
  }, [queryObj])

  useEffect(() => {
    const fetchGameChartData = async () => {
      try {
       
        const [chartDataGame] = await Promise.all([
          getGameUsageChart(removeEmptyAttributes(chartPayload)),
        ])

        setChartData(chartDataGame)
      } catch (error) {
        message.error('Failed to load chart data.')
      } finally {
        setLoading(false)
      }
    }
    fetchGameChartData()
  }, [groupByForGame])
  const handleGroupByForGameChange = (e) => {
    setGroupByForGame(e.target.value)
    handlePeriodChange(e.target.value)
  }
  const handlePeriodChange = (period) => {
    const range = setDateRange(period)
    if (range) {
      setStartDate(range.startDate)
      setEndDate(range.endDate)
      appendSearchForm({ startDate: range.startDate })
      appendSearchForm({ endDate: range.endDate })
    }
  }
  function setDateRange(period) {
               
             
               let startDate, endDate;
             
               switch (period) {
                 case 'day':
                   startDate = moment().startOf('day').format('YYYY-MM-DD');
                   endDate = moment().endOf('day').format('YYYY-MM-DD');
                   break;
                 case 'week':
                                  endDate = moment().startOf('day').format('YYYY-MM-DD');
                                  startDate = moment().subtract(1, 'week').format('YYYY-MM-DD');
                                  break;
                                case 'month':
                                  endDate = moment().startOf('day').format('YYYY-MM-DD');
                                  startDate = moment().subtract(1, 'month').format('YYYY-MM-DD');
                                  break;
                 case 'hour':
                   startDate = moment().startOf('day').format('YYYY-MM-DD');
                   endDate = moment().endOf('day').format('YYYY-MM-DD');
                   break;
                 
                 default:
                   console.error('Invalid period:', period);
                   return null; 
               }
               return { startDate, endDate };
             }
             const handlePdfClick = () => {
               if (categoryMap) {
                 appendSearchFormMap({ categoryMap: convertedMap })
}
              appendSearchForm({ buttonAction: 'Generate Pdf' })
              submitSearchForm()
            }
          
            const handleCsvClick = () => {
               if (categoryMap) {
                 appendSearchFormMap({ categoryMap: convertedMap })
}
              appendSearchForm({ buttonAction: 'Generate Csv' })
              submitSearchForm()
            }
             const mncmccMap = Object.fromEntries(
                        mncmccOptions.map(({ value, label }) => [value, label])
                      );
                      const convertedMap: Map<string, string> = new Map(
   
    Array.from(categoryMap.entries()).map(([key, valueSet]) => [
        
        key, 
       
        Array.from(valueSet).join(', ') 
    ])
);
  return (
    <>
      <GameUsageReportSearch
        appendSearchForm={appendSearchForm}
        submitSearchForm={submitSearchForm}
      />
      <Row gutter={20} className="master-data-overview">
        <Col span={11}>
          <Card
            title="User Game Time"
            extra={
              <Radio.Group
                size={'large'}
                value={groupByForGame}
                onChange={handleGroupByForGameChange}
              >
                {chartDateType.map((date) => (
                  <Radio.Button key={date.value} value={date.value}>
                    {date.label}
                  </Radio.Button>
                ))}
              </Radio.Group>
            }
          ></Card>
          <Card>
            <div className="chart-wrap">
            <HourlyAppUsageChart data={chartData}  chartHeight={200} />
            </div>
          </Card>
        </Col>
        <Col span={4}>
          <div className="stats-card-wrap">
                    <Card
            style={{
             
              borderRadius: '10px',
              padding: '1rem',
              color: 'white',
            }}
            bodyStyle={{ padding: 0 }}
          >
            <Statistic
              title={<span style={{ color: '#ccc', fontSize: '13px' }}>Total User</span>}
              valueRender={() => (
                <span style={{ color: '#3A63FF', fontSize: '28px', fontWeight: 700 }}>
                  {metricsData?.reduce((sum, item) => sum + item.totalUsers, 0) || 0}
                </span>
              )}
            />
          
           <div style={{ marginTop: '3rem' }}>
    <div style={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    borderBottom: '1px solid #444', 
    paddingBottom: '0.25rem', 
    marginBottom: '0.25rem' 
  }}>
    <span style={{ color: '#aaa', fontSize: '11px' }}>Premium</span>
    <span style={{ color: '#BB3684', fontWeight: 600 }}>
      {metricsData?.find(i => i.accessLevel === 'SUBSCRIBED')?.totalUsers || 0}
    </span>
  </div>

 
  <div style={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    borderBottom: '1px solid #444', 
    paddingBottom: '0.25rem', 
    marginBottom: '0.25rem' 
  }}>
    <span style={{ color: '#aaa', fontSize: '11px' }}>Freemium</span>
    <span style={{ color: '#9E36BB', fontWeight: 600 }}>
      {metricsData?.find(i => i.accessLevel === 'FREEMIUM')?.totalUsers || 0}
    </span>
  </div>
          
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.25rem' }}>
                <span style={{ color: '#aaa', fontSize: '11px' }}>Guest</span>
                <span style={{ color: '#36BB9C', fontWeight: 600 }}>
                  {metricsData?.find(i => i.accessLevel === 'GUEST')?.totalUsers || 0}
                </span>
              </div>
            </div>
          </Card>
          
          
          
                    </div>
                  </Col>
                  <Col span={5}>
                    <div className="stats-card-wrap">
                    <Card
            style={{
              
              borderRadius: '10px',
              padding: '1rem',
              color: 'white',
            }}
            bodyStyle={{ padding: 0 }}
          >
            <Statistic
              title={<span style={{ color: '#ccc', fontSize: '13px' }}>Total Hour</span>}
              valueRender={() => (
                <span style={{ color: '#3A63FF', fontSize: '28px', fontWeight: 700 }}>
                  {formatTimeWithSuffix(metricsData?.reduce((sum, item) => sum + item.totalDuration, 0) || 0)}
                </span>
              )}
              
            
            />
          
          </Card>
          <Card
            style={{
              
              borderRadius: '10px',
              padding: '1.25rem',
              color: 'white',
            }}
            bodyStyle={{ padding: 0 }}
          >
            <Statistic
              title={<span >Avg. Time Per Day</span>}
            
              valueRender={() => (
                <span style={{ color: '#3A63FF', fontSize: '28px', fontWeight: 700 }}>
                  {formatTimeWithSuffix(
                metricsData?.reduce((sum, item) => sum + item.medianDuration, 0) || 0
              )}
                </span>
              )}
            />
          
          </Card>
          </div>
        </Col>
        <Col span={4}>
                  <div className="stats-card-wrap">
                 <Card
          style={{
            
            borderRadius: '10px',
            padding: '1rem',
            color: 'white',
          }}
          bodyStyle={{ padding: 0 }}
        >
          <Statistic
            title={<span style={{ color: '#ccc', fontSize: '13px' }}>Time Range Play Most</span>}
           valueRender={() => (
          <span style={{ color: '#3A63FF', fontSize: '28px', fontWeight: 700 }}>
            {metricsData?.find(i => i.accessLevel === 'SUBSCRIBED')?.mostActiveHourRange || ""}
          </span>
        )}
            
          
          />
        
        </Card>
        <Card
          style={{
           
            borderRadius: '10px',
            padding: '1rem',
            color: 'white',
            
          }}
          bodyStyle={{ padding: 0 }}
        >
          <div style={{ marginBottom: '0.1rem', fontSize: '14px', color: '#ccc' }}>
            Device Played Most
          </div>
        
          <div style={{ display: 'flex',  gap: '1.5rem' }}>
            <div>
              <div style={{ fontSize: '22px', color: '#3A63FF', fontWeight: 600 }}>
             {(metricsData && metricsData.length > 0 && metricsData[0].iosDevicePercentage !== undefined)
  ? `${(100 - metricsData[0].iosDevicePercentage).toFixed(2)}%`
  : '0.00%'}
                
              </div>
              <div style={{ fontSize: '13px', color: '#fff', marginTop: '0.05rem' }}>
                Android
              </div>
            </div>
        
            <div>
              <div style={{ fontSize: '22px', color: '#3A63FF', fontWeight: 600 }}>
              {(metricsData?.[0]?.iosDevicePercentage || 0).toFixed(2)}%
              </div>
              <div style={{ fontSize: '13px', color: '#fff', marginTop: '0.05rem' }}>
                IOS
              </div>
            </div>
          </div>
        </Card>
                  </div>
                  </Col>
      </Row>
      <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
  <Col>
    <span style={{fontSize:24 }}>
      Search Results ({pageData.total})
    </span>
  </Col>
  <Col>
    <Select
      placeholder="Export"
      style={{ width: 160 }}
      onSelect={(value) => {
        if (value === 'pdf') {
          handlePdfClick();
        } else if (value === 'csv') {
          handleCsvClick();
        }
      }}
      allowClear
    >
      <Select.Option value="pdf">Export as PDF</Select.Option>
      <Select.Option value="csv">Export as CSV</Select.Option>
    </Select>
  </Col>
</Row>
      <DndProvider backend={HTML5Backend}>
        <Table
          className="table-sorting"
          rowKey="eventId"
          dataSource={pageData.data}
          loading={pageData.loading}
          onChange={handleTableChange} 
          pagination={{
            current: parseInt(pageData.query.page) + 1,
            total: pageData.total,
            pageSize: parseInt(pageData.query.pageSize) || 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100'],
           
          }}
        >
          <Column width={120} dataIndex="gameTitle" title="Game" sorter={{ multiple: 3 }} />
          <Column dataIndex="userName" title="User Name" sorter={{ multiple: 1 }} />
          <Column
            dataIndex="accessLevel"
            title="User Type"
            sorter={{ multiple: 1 }}
            render={(text) => {
              const colorStyle: React.CSSProperties = {
                color: 'white',
                textAlign: 'center',
                width: 100,
                display: 'inline-block',
                borderRadius: '4px',
                padding: '0 8px',
              };
          
              switch (text) {
                case 'FREEMIUM':
                      colorStyle.backgroundColor = 'rgba(158, 54, 187, 0.78)'; 
                      colorStyle.color = 'rgba(222, 222, 222, 1)';
                      break;
                    case 'GUEST':
                      colorStyle.backgroundColor = 'rgba(54, 187, 156, 0.78)'; 
                      colorStyle.color = 'rgba(222, 222, 222, 1)';
                      break;
                    case 'SUBSCRIBED':
                      colorStyle.backgroundColor = 'rgba(187, 54, 132, 0.78)';
                      colorStyle.color = 'rgba(222, 222, 222, 1)';
                      break;
                    default:
                      colorStyle.backgroundColor = 'rgba(217, 217, 217, 0.78)';
                      colorStyle.color = 'rgba(222, 222, 222, 1)';
              }
          
              const displayText = text === 'SUBSCRIBED' ? 'PREMIUM' : text;
                              return <Tag  style={colorStyle}>{displayText}</Tag>
            }}
          />
          <Column dataIndex="deviceType" title="Device" sorter={{ multiple: 1 }} />
          <Column dataIndex="eventDate" title="Record Date" sorter={{ multiple: 5 }} />
          <Column
            dataIndex="eventDuration"
            title="Duration" sorter={{ multiple: 4 }}
            render={(text) => <span>{text} sec</span>}
          />
          <Column dataIndex="points" title="points" sorter={{ multiple: 3 }} />
          <Column
            dataIndex="gender"
            title="Gender"
            sorter={{ multiple: 1 }}
            filters={[
              {
                text: 'Male',
                value: 'MALE',
              },
              {
                text: 'Female',
                value: 'FEMALE',
              },
            ]}
            filterMode="tree"
            onFilter={(value: string, record: any) => record.gender === value}
          />
          <Column dataIndex="age" title="Age" sorter={{ multiple: 1 }} />
          <Column dataIndex="providerCountry" title="Country" sorter={{ multiple: 2 }} />
          <Column
  title="Source"
  dataIndex="mncmcc"
  sorter={{ multiple: 1 }}
  render={(value: string) => mncmccMap[value] || value}
/>
<Column<{ rating: number; votes: number }>
  title="Rating"
  dataIndex="rating"
  sorter={{ multiple: 2 }}
  render={(_, record) => {
    
    if (record.votes > 0) {
     
      const average = record.rating / record.votes;
      return average.toFixed(1);
    }
    
    return "0.0";
  }}
/>
<Column<{ votes: number }>
  title="Votes"
  dataIndex="votes"
  sorter={{ multiple: 1 }}
  render={(_, record) => {
    if (record.votes > 0) {
    return record.votes;
  }
  return "0";
}}
/>
           <Column title="Categories" dataIndex="categories" render={(categories) => categories.join(', ')} />

          <Column<{ userName: string }>
            title="Action"
            key="url"
            render={(_, record) => (
              <Space size="middle">
                <Link to={`/users/detail/${record.userName}`} className="link-btn">
                  <EyeOutlined />
                </Link>
              </Space>
            )}
          />
        </Table>
      </DndProvider>
    </>
  )
}

GameUsageReportPage.displayName = 'GameUsageReportPage'
export default GameUsageReportPage
